import { z } from "zod";
import apiOSS from "./apiOSS";

export const cohortSchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
  description: z.string().optional(),
  size: z.number(),
  color: z.string().optional(),
});
export type Cohort = z.infer<typeof cohortSchema>;

export const cohortsResponseSchema = z.object({
  cohorts: z.array(cohortSchema),
});
export type CohortsResponse = z.infer<typeof cohortsResponseSchema>;

const COHORT_URL = `/medical/v1/cohort`;

export async function getCohorts(): Promise<Cohort[]> {
  const response = await apiOSS.get(COHORT_URL);
  const parsed = cohortsResponseSchema.parse(response.data);
  return parsed.cohorts;
}
